'use strict';

var selectFromObject = require('./selectFromObject');

function objectSelect(obj, f) {
  return selectFromObject(obj, f, true);
}

module.exports = objectSelect;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/internal/objectSelect.js
// module id = 797
// module chunks = 0